"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegAm = void 0;
const base_1 = require("./base");
const am_1 = require("../services/am");
/**
 * Amplitude
 */
class AnIntegAm extends base_1.AnIntegBase {
    static isLoaded() {
        return am_1.AnServAm.isLoaded();
    }
    static sendInit(siteCategory, userId, email, coupon) {
        am_1.AnServAm.sendInit(this.getPixelId(siteCategory), null, null, coupon);
        return true;
    }
    static sendTrackQuizStyleLegacy(siteCategory, response) {
        const title = "Legacy: Quiz Question Answered: Style";
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), title, {
            answer: response
        });
        return true;
    }
    static sendTrackQuizDayLook(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Quiz Question Answered: Day Look", { answer: response });
        return true;
    }
    static sendTrackQuizNightLook(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Quiz Question Answered: Night Look", { answer: response });
        return true;
    }
    static sendTrackQuizShoeStyle(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Quiz Question Answered: Shoe Style", { answer: response });
        return true;
    }
    static sendTrackQuizExerciseFrequency(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Quiz Question Answered: Exercise Frequency", { answer: response });
        return true;
    }
    static sendTrackQuizFirstSelectedPackage(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Quiz Question Answered: First Selected Package", { answer: response });
        return true;
    }
    static sendTrackQuizTopSize(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Quiz Question Answered: Top Size", { answer: response });
        return true;
    }
    static sendTrackQuizTopSizeLegacy(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Quiz Question Answered: Top Size", { answer: response });
        return true;
    }
    static sendTrackQuizBottomSize(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Quiz Question Answered: Bottom Size", { answer: response });
        return true;
    }
    static sendTrackQuizBottomSizeLegacy(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Quiz Question Answered: Bottom Size", { answer: response });
        return true;
    }
    static sendTrackQuizBottomFit(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Quiz Question Answered: Bottom Fit", { answer: response });
        return true;
    }
    static sendTrackQuizBottomFitLegacy(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Quiz Question Answered: Bottom Fit", { answer: response });
        return true;
    }
    static sendTrackQuizShoeSize(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Quiz Question Answered: Shoe Size", { answer: response });
        return true;
    }
    static sendTrackQuizShoeSizeLegacy(siteCategory, response) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Quiz Question Answered: Shoe Size", { answer: response });
        return true;
    }
    static sendTrackClubCheckoutStart(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Arrive At Club Checkout", {});
        return true;
    }
    static sendTrackArriveSignupLoginLegacy(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Arrive At Club Signup Login", {});
        return true;
    }
    static sendTrackClubAddressInfoLegacy(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Arrive At Club Address Info", {});
        return true;
    }
    static sendTrackPlanSelected(siteCategory, planName) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Club Checkout Plan Selected", {
            plan: planName
        });
        return true;
    }
    static sendTrackPlanSelectedLegacy(siteCategory, planName, explicit) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Club Checkout Plan Selected", {
            plan: planName,
            explicit: explicit
        });
        return true;
    }
    static sendTrackClubLanding(siteCategory, coupon) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Arrived At Club Landing", { page_coupon: coupon });
        return true;
    }
    static sendTrackClubLandingLegacy(siteCategory, coupon) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Arrived At Club Landing", { page_coupon: coupon });
        return true;
    }
    static sendTrackClubLanding3(siteCategory, coupon) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Landing 3: Arrived At Club Landing", { page_coupon: coupon });
        return true;
    }
    static sendTrackClubLanding4(siteCategory, coupon) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Landing 4: Arrived At Club Landing", { page_coupon: coupon });
        return true;
    }
    static sendTrackClickCtaLanding3(siteCategory, testName, ctaName, variantName, targetUrl) {
        //
        // See: https://support.google.com/analytics/answer/1136920?hl=en
        //
        let processed = false;
        const redirect = () => {
            if (processed) {
                return true;
            }
            processed = true;
            document.location.href = targetUrl;
            return true;
        };
        setTimeout(() => {
            redirect();
            return true;
        }, 6000);
        am_1.AnServAm.sendCustEventCb(this.getPixelId(siteCategory), "Landing 3: Clicked CTA", {
            testName: testName,
            ctaName: ctaName,
            variantName: variantName
        }, () => {
            redirect();
            return true;
        });
        return true;
    }
    static sendTrackClickCtaLanding4(siteCategory, testName, ctaName, variantName, targetUrl) {
        //
        // See: https://support.google.com/analytics/answer/1136920?hl=en
        //
        let processed = false;
        const redirect = () => {
            if (processed) {
                return true;
            }
            processed = true;
            document.location.href = targetUrl;
            return true;
        };
        setTimeout(() => {
            redirect();
            return true;
        }, 6000);
        am_1.AnServAm.sendCustEventCb(this.getPixelId(siteCategory), "Landing 4: Clicked CTA", {
            testName: testName,
            ctaName: ctaName,
            variantName: variantName
        }, () => {
            redirect();
            return true;
        });
        return true;
    }
    static sendTrackQuizStartLegacy(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Quiz Started", {});
        return true;
    }
    static sendTrackQuizStart(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Quiz Started", {});
        return true;
    }
    static sendTrackAddBillingInfo(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Added Billing Info", {});
        return true;
    }
    static sendTrackAddBillingInfoLegacy(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Added Billing Info", {});
        return true;
    }
    static sendTrackAddShippingInfo(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Added Shipping Info", {});
        return true;
    }
    static sendTrackAddShippingInfoLegacy(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Added Shipping Info", {});
        return true;
    }
    static sendTrackClubAddPaymentInfo(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Added Payment Info", {});
        return true;
    }
    static sendTrackClubAddPaymentInfoLegacy(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Added Payment Info", {});
        return true;
    }
    static sendTrackSubmittedPaymentReviewLegacy(siteCategory) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Submitted Payment Review", {});
        return true;
    }
    static sendTrackClubAccountCreate(siteCategory, userId, email) {
        am_1.AnServAm.sendIdentify(this.getPixelId(siteCategory), userId, email);
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Subscription User Email Added", {});
        return true;
    }
    static sendTrackClubAccountCreateLegacy(siteCategory, userId, email) {
        am_1.AnServAm.sendIdentify(this.getPixelId(siteCategory), userId, email);
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Subscription User Email Added", {});
        return true;
    }
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Subscription Thank You", {
            price: price,
            style: style,
            color: color,
            coupon: coupon
        });
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        am_1.AnServAm.sendCustEvent(this.getPixelId(siteCategory), "Legacy: Subscription Thank You", {
            price: price,
            style: style,
            color: color,
            coupon: coupon
        });
        return true;
    }
}
exports.AnIntegAm = AnIntegAm;
AnIntegAm.shouldSendTrackQuizStyleLegacy = true;
AnIntegAm.shouldSendTrackQuizDayLook = true;
AnIntegAm.shouldSendTrackQuizNightLook = true;
AnIntegAm.shouldSendTrackQuizShoeStyle = true;
AnIntegAm.shouldSendTrackQuizExerciseFrequency = true;
AnIntegAm.shouldSendTrackQuizFirstSelectedPackage = true;
AnIntegAm.shouldSendTrackQuizTopSize = true;
AnIntegAm.shouldSendTrackQuizTopSizeLegacy = true;
AnIntegAm.shouldSendTrackQuizBottomSize = true;
AnIntegAm.shouldSendTrackQuizBottomSizeLegacy = true;
AnIntegAm.shouldSendTrackQuizBottomFit = true;
AnIntegAm.shouldSendTrackQuizBottomFitLegacy = true;
AnIntegAm.shouldSendTrackQuizShoeSize = true;
AnIntegAm.shouldSendTrackQuizShoeSizeLegacy = true;
AnIntegAm.shouldSendTrackClubLanding = true;
AnIntegAm.shouldSendTrackClubLandingLegacy = true;
AnIntegAm.shouldSendTrackClubLanding3 = true;
AnIntegAm.shouldSendTrackClubLanding4 = true;
AnIntegAm.shouldSendTrackClickCtaLanding3 = true;
AnIntegAm.shouldSendTrackClickCtaLanding4 = true;
AnIntegAm.shouldSendTrackQuizStart = true;
AnIntegAm.shouldSendTrackQuizStartLegacy = true;
AnIntegAm.shouldSendTrackClubCheckoutStart = true;
AnIntegAm.shouldSendTrackArriveSignupLoginLegacy = true;
AnIntegAm.shouldSendTrackClubAccountCreate = true;
AnIntegAm.shouldSendTrackClubAccountCreateLegacy = true;
AnIntegAm.shouldSendTrackPlanSelected = true;
AnIntegAm.shouldSendTrackPlanSelectedLegacy = true;
AnIntegAm.shouldSendTrackAddBillingInfo = true;
AnIntegAm.shouldSendTrackAddBillingInfoLegacy = true;
AnIntegAm.shouldSendTrackAddShippingInfo = true;
AnIntegAm.shouldSendTrackAddShippingInfoLegacy = true;
AnIntegAm.shouldSendTrackClubAddPaymentInfo = true;
AnIntegAm.shouldSendTrackClubAddPaymentInfoLegacy = true;
AnIntegAm.shouldSendTrackSubmittedPaymentReviewLegacy = true;
AnIntegAm.shouldSendTrackClubThankyou = true;
AnIntegAm.shouldSendTrackClubThankyouLegacy = true;
AnIntegAm.pixelId = {
    prod: {
        defaultId: "290a399587da0dcc696ba1b8462075f0",
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: "5025e9308583edd1715fd7f76279659c",
        ecomm: null,
        club: null,
    },
};
